import { render, staticRenderFns } from "./FeatureCardMasterplanRp.vue?vue&type=template&id=54620d74&"
import script from "./FeatureCardMasterplanRp.vue?vue&type=script&lang=js&"
export * from "./FeatureCardMasterplanRp.vue?vue&type=script&lang=js&"
import style0 from "./FeatureCardMasterplanRp.vue?vue&type=style&index=0&id=54620d74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports